import { render, staticRenderFns } from "./FriendCell.vue?vue&type=template&id=a58cf67a&scoped=true&"
import script from "./FriendCell.vue?vue&type=script&lang=js&"
export * from "./FriendCell.vue?vue&type=script&lang=js&"
import style0 from "./FriendCell.vue?vue&type=style&index=0&id=a58cf67a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a58cf67a",
  null
  
)

export default component.exports